/**
 * Created by nmayer on 09.06.16.
 */
define('modules/settings/metadata/MetadataSetListController',[
        'modules/module',
        'settings',
        'modules/basemodule/controllers/EntityListController'
    ],
    function (module) {
        'use strict';
        module.controller('MetadataSetListController', ['$scope', '$controller', 'BASE_TEMPLATES_PATH',
            function ($scope, $controller, BASE_TEMPLATES_PATH) {

                angular.extend(this, $controller('EntityListController', {
                    $scope: $scope
                }));

                $scope.tableOptions.fields = [
                    {
                        id: 'NAME',
                        heading:    'Name',
                        attribute:  'name'
                    }
                ];
                $scope.formState = 'root.metadataset';

                $scope.init('MetaDataSet');
            }
        ]);
    }
);


